import { css } from '@emotion/react'
import { Theme, useTheme } from 'bold-ui'
import { SideMenuSublink } from 'components/side-menu-navegation/SideMenuSublink'
import { TipoAcompanhamentoEnum } from 'graphql/types.generated'
import { Dispatch, SetStateAction } from 'react'
import { Accordion } from 'react-accessible-accordion'
import { useLocation } from 'react-router'

import { ACOMPANHAMENTOS_PRE_NATAL_URL, AcompanhamentoSideMenuItem } from '../getAcompanhamentosSideMenuItems'
import { INFO_GESTACAO_URL } from '../pre-natal/AcompanhamentoPreNatalTabs'
import { AcompanhamentosSideMenuItem } from './AcompanhamentosSideMenuItem'

interface AcompanhamentosSideMenuProps {
  basePath: string
  headerRef?: React.MutableRefObject<HTMLDivElement | undefined>
  isVisualizacaoProntuario: boolean
  items: Record<TipoAcompanhamentoEnum, AcompanhamentoSideMenuItem>
  selectedMenu?: TipoAcompanhamentoEnum
  setSelectedMenu: Dispatch<SetStateAction<TipoAcompanhamentoEnum>>
}

export function AcompanhamentosSideMenu(props: Readonly<AcompanhamentosSideMenuProps>) {
  const { basePath, headerRef, isVisualizacaoProntuario, items, selectedMenu, setSelectedMenu } = props
  const menuItems = Object.entries(items) as [TipoAcompanhamentoEnum, AcompanhamentoSideMenuItem][]

  const location = useLocation()
  const informacoesPath = `${basePath}/${ACOMPANHAMENTOS_PRE_NATAL_URL}/${INFO_GESTACAO_URL}${location.search}`

  const theme = useTheme()
  const styles = createStyles(theme)

  const handleMenuClick = (menu: TipoAcompanhamentoEnum) => {
    setSelectedMenu(menu)
  }

  const scrollWithOffset = (element: HTMLElement) => {
    const headerHeight = headerRef?.current?.clientHeight
    const y = element.getBoundingClientRect().top + window.scrollY - (headerHeight || 0)
    const scroll = headerHeight && window.scrollY > headerHeight ? 'smooth' : 'auto'
    window.scrollTo({ behavior: scroll, top: y })
  }

  return (
    <aside css={styles.aside}>
      <Accordion
        allowZeroExpanded
        preExpanded={selectedMenu && [items[selectedMenu]?.title]}
        css={css(styles.accordion)}
      >
        {menuItems.map(
          ([chave, item]: [TipoAcompanhamentoEnum, AcompanhamentoSideMenuItem]) =>
            item.isVisible && (
              <AcompanhamentosSideMenuItem
                title={item.title}
                isMenuActive={selectedMenu === chave}
                onClickMenuItem={() => handleMenuClick(chave)}
                key={item.title}
                icon={item.icon}
                alt={item.alt}
                color={item.color}
              >
                {item.subItems.map((subItem) => (
                  <SideMenuSublink
                    scroll={!isVisualizacaoProntuario ? scrollWithOffset : undefined}
                    to={chave === TipoAcompanhamentoEnum.PRE_NATAL ? `${informacoesPath}${subItem.to}` : subItem.to}
                    key={subItem.title}
                    title={subItem.title}
                    sublinkStyle={css`
                      &.active {
                        color: ${item.color.c40};
                      }
                    `}
                  />
                ))}
              </AcompanhamentosSideMenuItem>
            )
        )}
      </Accordion>
    </aside>
  )
}

const createStyles = (theme: Theme) => ({
  aside: css`
    padding: 0;
    width: 100%;
    border: 0;
    height: auto;
    overflow: visible;
  `,

  accordion: css`
    border: 1px ${theme.pallete.gray.c60} solid;
  `,
})
